@if (icon === 'company') {
    <img class="company-icon" src="/assets/images/logo-small.png" />
} @else {
    <i class="fa-duotone fa-{{ icon }}"></i>
}
